export default [
  {
    path: '/everything/notebooks',
    name: 'projects-everything-notebooks-list',
    props: true,
    component: () =>
      import(
        /* webpackChunkName: "everything-notebooks-list" */ '../projects/project/notebooks/NotebookList.vue'
      ),
  },
];
